import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
} from 'react';
import {
  ChatMessageSource,
  DepositionSummaryMessageSource,
} from '@app/types/chat';
import { GroundXSearch } from '@api/groundx/model/types';

export interface PageValues {
  backButton?: boolean;
  backButtonAction?: () => void;
  backNavigationLabel?: string;
  title?: string | ReactNode;
  description?: string;
  descriptionElement?: () => ReactNode;
  tooltipText?: string;
  additional?: () => ReactNode;
  versionSelector?: () => ReactNode;
  searchValue?: string;
  loading?: boolean;
  generateModalOpened?: boolean;
  generateTemplateModalOpened?: boolean;
  generateDepositionSummaryModalOpened?: boolean;
  generateUseCaseModalOpened?: boolean;
  setGenerateModalOpened?: () => void;
  versionsModalOpened?: boolean;
  setVersionsModalOpened?: () => void;
  resultModalOpened?: boolean;
  showVersions?: boolean;
  withBorder?: boolean;
  disablePadding?: boolean;
  hideTop?: boolean;
  fullPage?: boolean;
  tooltipQuestionTitle?: string;
  chatSourceModalOpened?: boolean;
  depositionSummarySourceModalOpened?: boolean;
  groundXModalOpened?: boolean;
  chatMessageSource?: ChatMessageSource[];
  depositionSummaryMessageSource?: DepositionSummaryMessageSource[];
  groundXSearch?: GroundXSearch;
  generatingDocumentId?: string;
  generatingDocumentType?: string;
  progressModalAutoMinimize?: boolean;
  progressModalExpandedAt?: number;
}

export interface PageContextValues {
  values?: PageValues;
  setValues?: Dispatch<SetStateAction<Partial<PageValues>>>;
}

/**
 * @type {import("react").Context<PageContextValues>}
 * */

const PageContext = createContext<PageContextValues>({
  values: {
    loading: false,
    fullPage: false,
    generateModalOpened: false,
    withBorder: false,
    disablePadding: false,
    versionsModalOpened: false,
    resultModalOpened: false,
    chatSourceModalOpened: false,
    depositionSummarySourceModalOpened: false,
    groundXModalOpened: false,
    generateTemplateModalOpened: false,
    generateDepositionSummaryModalOpened: false,
    generateUseCaseModalOpened: false,
  },
});

export const usePageContext = () => useContext(PageContext);

export { PageContext };
